import React, { useState } from "react";
import { pdf } from "@react-pdf/renderer";

const ReportDownloadButton = ({ ReportPDF, filteredRows, reportTitle , grandColumnTotals}) => {
  const [loading, setLoading] = useState(false);

  const downloadPDF = async () => {
    console.log("filteredRows ", filteredRows)
    try {
      setLoading(true);

      const blob = await pdf(
        <ReportPDF rows={filteredRows} title={reportTitle} grandColumnTotals={grandColumnTotals} />
      ).toBlob();

      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${reportTitle}.pdf`;
      a.click();

      URL.revokeObjectURL(url);
    } catch (err) {
      console.error("PDF FAILED:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      onClick={downloadPDF}
      disabled={loading}
      className="rounded bg-blue-600 px-4 py-2 text-white"
    >
      {loading ? "Generating PDF..." : "Download PDF"}
    </button>
  );
};

export default ReportDownloadButton;
